import { Container } from "./styles";
import { motion } from "framer-motion";

export function Experience() {
  const experiences = [
    {
      company: "TAD industries",
      role: "Backend Developer",
      duration: "Feb 2025 – Present",
      location: "Tashkent, Uzbekistan",
      details: [
        "Currently working as a specialized AI engineer, building AI chatbots and developing backend AI solutions",
        "Utilize local LLM models to reduce the cost of AI applications",
        "What are I using: using multiple agents as one agent, tool calling, Model context protocol, Microservices, etc.",
        "Fine Tuning, ChromoDB, Websocket, Hono, Monorepo",
      ],
      commit: "feat: implement AI chatbot and vector storage",
    },
    {
      company: "Dynamic Soft",
      role: "Backend Developer",
      duration: "June 2024 – Jan 2025",
      location: "Tashkent, Uzbekistan",
      details: [
        "Developed a REST API using NestJS and PostgreSQL for LMS CRM, ERP, and E-Pos systems.",
        "Learned GitHub actions (CI/CD) to deploy applications 50% faster.",
        "Participated in 6+ ERP projects, including Avtoset.uz and Mebelhouse.",
        "Integrated third-party services like SMS, email, and payment systems (OCTO).",
      ],
      commit: "refactor: optimize ERP integrations and CI/CD pipelines",
    },
    {
      company: "Nahr Group",
      role: "Backend Developer",
      duration: "Jan 2024 – June 2024",
      location: "Tashkent, Uzbekistan",
      details: [
        "Developed moliyaviytahlil.uz using NestJS, PostgreSQL, and AWS S3.",
        "Used socket.io for real-time support chat.",
      ],
      commit: "initial: architect moliyaviytahlil.uz backend",
    },
  ];

  return (
    <Container id="experience">
      <div className="experience-section">
        <h2 className="section-title">Experience.log</h2>
        <div className="experience-list">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              className="experience-item"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="git-indicator">
                <span className="terminal-prompt">portfolio/oybek{">"}</span>
              </div>
              <div className="content">
                <div className="commit-hash">
                  commit {Math.random().toString(16).substring(2, 10)}
                </div>
                <h3 className="job-title">
                  {exp.role} | {exp.company}
                </h3>
                <p className="job-duration">
                  {exp.duration} | {exp.location}
                </p>
                <div className="commit-msg">{exp.commit}</div>
                <ul className="job-details">
                  {exp.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </Container>
  );
}
